export default "__VITE_ASSET__BMPiwpp___"